// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___1EKEr","head":"style__head___31TOF","fields":"style__fields___38k9P","bottom":"style__bottom___4NhlG","basic":"style__basic___2LnbI","informationWrapper":"style__informationWrapper___1fpzG","h":"style__h___1-K9L","information":"style__information___2mJ_b","input":"style__input___2fm1d","inputSpace":"style__inputSpace___25-3-","btn":"style__btn___1DKlq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payments/RequestToConnect/style.scss
// module id = 1450
// module chunks = 0